import { Box, Typography, Grid, Alert, Paper } from '@mui/material'
import EngineeringIcon from '@mui/icons-material/Engineering'
import FilterPanel from '../../components/FilterPanel'
import StatisticsPanel from '../../components/StatisticsPanel'
import EngineeringMetrics from '../../components/charts/EngineeringMetrics'
import { useFilters } from '../../context/FilterContext'
import { DataQualityBanner } from '../../components/ui/DataQualityContext'

function EngineeringAnalysis() {
  const { filteredData, activeFilterCount } = useFilters()

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <EngineeringIcon sx={{ fontSize: 32, color: 'primary.main' }} />
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            Engineering Metrics
          </Typography>
          <Typography variant="body2" color="text.secondary">
            HVAC engineering metrics (COP/EER) and statistical analysis
          </Typography>
        </Box>
      </Box>

      <Box sx={{ mb: 3 }}>
        <FilterPanel compact />
      </Box>
      <Box sx={{ mb: 3 }}>
        <DataQualityBanner compact />
      </Box>

      {activeFilterCount > 0 && (
        <Alert severity="info" sx={{ mb: 3 }}>
          Showing analysis for {filteredData.length} filtered studies.
        </Alert>
      )}

      <Grid container spacing={3}>
        {/* Statistics Panel - Full Width */}
        <Grid item xs={12}>
          <Paper sx={{ p: { xs: 1.5, sm: 2 }, overflow: 'auto' }}>
            <StatisticsPanel data={filteredData} title="Statistical Summary" />
          </Paper>
        </Grid>

        {/* Engineering Metrics - Full Width */}
        <Grid item xs={12}>
          <Paper sx={{ p: { xs: 1.5, sm: 2 }, overflow: 'auto' }}>
            <EngineeringMetrics data={filteredData} title="HVAC Engineering Metrics (COP/EER)" />
          </Paper>
        </Grid>
      </Grid>

      {/* Methodology Note */}
      <Alert severity="success" icon={false} sx={{ mt: 4 }}>
        <Typography variant="subtitle2" gutterBottom>
          Engineering Methodology
        </Typography>
        <Typography variant="body2">
          COP and EER values are derived from kW/Ton measurements using standard conversion factors:
          COP = 3.517/kW/Ton (per ASHRAE Handbook - Fundamentals), EER = 12/kW/Ton (per AHRI Standard 210/240).
          Statistical confidence intervals assume normal distribution.
        </Typography>
      </Alert>
    </Box>
  )
}

export default EngineeringAnalysis
